import { Component, OnInit } from '@angular/core';
import { NetworkStatusService } from './network-status.service';
import { CommonModule } from '@angular/common';
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
@Component({
    selector: 'app-network-status',
    templateUrl: './network-status.component.html',
    imports: [CommonModule, Toast, DialogModule],
    providers: [MessageService],
    styleUrls: ['./network-status.component.scss']
})
export class NetworkStatusComponent implements OnInit {
    isOnline = true;
    showPopup = false;
    message = '';
    Visible = false;
    constructor(
        private networkStatusService: NetworkStatusService,
        private messageService: MessageService
    ) {}

    previousStatus: boolean | null = null;
    ngOnInit(): void {
        this.networkStatusService.onlineStatus$.subscribe((status) => {
            // Only show popup if status actually changed
            if (this.previousStatus !== null && this.previousStatus !== status) {
                this.isOnline = status;
                console.log('Network status changed:', status ? 'Online' : 'Offline');

                this.message = this.isOnline ? '🎉 You are online again. Your connection has been restored.' : '🚫 Oops! You’re currently offline. Please check your internet connection. You may be logged out if the connection is not restored soon.';

                this.messageService.add({
                    severity: this.isOnline ? 'success' : 'error',
                    summary: this.isOnline ? 'Online' : 'Offline',
                    detail: this.message
                });

                this.showPopup = true;
                this.Visible = true;

                // Hide popup automatically after 3 seconds if online
                if (this.isOnline) {
                    setTimeout(() => {
                        this.showPopup = false;
                    }, 3000);
                }
            }

            // Save current status for next comparison
            this.previousStatus = status;
        });
    }
}
